import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    campusCitiesListLoading : true,
    campusCitiesListSuccess : null,
    campusCitiesListError : '',
    campusCityLoading : false,
    campusCitySuccess : null,
    campusCityError : '',
    allCampusListLoading : true,
    allCampusListSuccess : null,
    allCampusListError : '',
    campusDetailLoading : false,
    campusDetailSuccess : null,
    campusDetailError : '',
    campusCitiesLoading : true,
    campusCitiesSuccess : null,
    campusCitiesError : '',
    campusesLoading:false,
    campuses:[],
    campusesError: null
}


export const campusSlice = createSlice({
    name: 'campus',
    initialState,
    reducers: {
        setCampusCitiesListLoading: (state, action) => {
            state.campusCitiesListLoading = true;
            state.campusCitiesListSuccess = null;
            state.campusCitiesListError = '';
        },
        setCampusCitiesListSuccess: (state, action) => {
            state.campusCitiesListLoading = false;
            state.campusCitiesListSuccess = action.payload;
            state.campusCitiesListError = '';
        },
        setCampusCitiesListError: (state, action) => {
            state.campusCitiesListLoading = false;
            state.campusCitiesListSuccess = null;
            state.campusCitiesListError = action.payload;
        },
        getCampusCityLoading: (state, action) => {
            state.campusCityLoading = true;
            state.campusCitySuccess = action.payload;
            state.campusCityError = '';
        },
        getCampusCitySuccess: (state, action) => {
            state.campusCityLoading = false;
            state.campusCitySuccess = action.payload;
            state.campusCityError = '';
        },
        getCampusCityError: (state, action) => {
            state.campusCityLoading = false;
            state.campusCitySuccess = null;
            state.campusCityError = action.payload;
        },
        setAllCampusListLoading: (state, action) => {
            state.allCampusListLoading = true;
            state.allCampusListSuccess = null;
            state.allCampusListError = '';
        },
        setAllCampusListSuccess: (state, action) => {
            state.allCampusListLoading = false;
            state.allCampusListSuccess = action.payload;
            state.allCampusListError = '';
        },
        setAllCampusListError: (state, action) => {
            state.allCampusListLoading = false;
            state.allCampusListSuccess = null;
            state.allCampusListError = action.payload;
        },
        getCampusDetailLoading: (state, action) => {
            state.campusDetailLoading = true;
            state.campusDetailSuccess = action.payload;
            state.campusDetailError = '';
        },
        getCampusDetailSuccess: (state, action) => {
            state.campusDetailLoading = false;
            state.campusDetailSuccess = action.payload;
            state.campusDetailError = '';
        },
        getCampusDetailError: (state, action) => {
            state.campusDetailLoading = false;
            state.campusDetailSuccess = null;
            state.campusDetailError = action.payload;
        },
        setCampusCitiesLoading: (state, action) => {
            state.campusCitiesLoading = true;
            state.campusCitiesSuccess = null;
            state.campusCitiesError = '';
        },
        setCampusCitiesSuccess: (state, action) => {
            state.campusCitiesLoading = false;
            state.campusCitiesSuccess = action.payload;
            state.campusCitiesError = '';
        },
        setCampusCitiesError: (state, action) => {
            state.campusCitiesLoading = false;
            state.campusCitiesSuccess = null;
            state.campusCitiesError = action.payload;
        },
        setCampusListLoading: (state, action) => {
            state.campusesLoading = true;
            state.campuses = [];
            state.campusesError = '';
        },
        setCampusListSuccess: (state, action) => {
            state.campusesLoading = false;
            state.campuses = action.payload?.map((item) => ({ ...item, value: item.id, label: item.title }))
            state.campusesError ='';
        },
        setCampusListError: (state, action) => {
            state.campusesLoading = false;
            state.campuses = [];
            state.campusesError = action.payload;
        },
        resetCampusCity: (state, action) => {
            state.campusCitySuccess = null
        },
        resetCampusDetails: (state, action) => {
            state.campusDetailSuccess = null
        },
    },
})

// Action creators are generated for each case reducer function
export const { setCampusCitiesListLoading, setCampusCitiesListSuccess, setCampusCitiesListError, getCampusCityLoading, getCampusCitySuccess,getCampusCityError,resetCampusCity,setAllCampusListLoading, setAllCampusListSuccess, setAllCampusListError, getCampusDetailLoading, getCampusDetailSuccess, getCampusDetailError,resetCampusDetails, setCampusCitiesLoading,setCampusCitiesSuccess,setCampusCitiesError, setCampusListLoading, setCampusListSuccess, setCampusListError} = campusSlice.actions

export default campusSlice.reducer;